












































































import { Component, Vue } from "vue-property-decorator";
// types
import { PlayerLog, PlayerLogFilterDto } from "@/services/players/types";
import { playerLogFields } from "@/components/players/fields/playerLogFields";
// service methods
import { getLogs } from "@/services/players/playerService";
import { calendarConfigs } from "@/services/functional-calendar";
// components
import FunctionalCalendar from "vue-functional-calendar/src/components/FunctionalCalendar.vue";
import moment from "moment";

@Component({
    components: { FunctionalCalendar }
})
export default class PlayerLogsModal extends Vue {
    // local state
    playerId = "";
    logs = [] as PlayerLog[];
    startDate = {} as any;
    endDate = {} as any;
    searchQuery = "";
    fields = playerLogFields;

    // computed
    get filteredData(): any[] {
        return this.logs &&
            this.logs.filter(x => this.searchQuery.length === 0 ||
                x.message.toLowerCase().includes(this.searchQuery.toLowerCase()))
                .map(x => ({
                    id: x.id,
                    log: `${moment(x.createdOnUtc).format("DD-MM-YYYY HH:mm")} - ${x.message.length > 50 ? x.message.substring(0, 50) + "..." : x.message}`,
                    originalMessage: x.message
                }));
    }

    get fromDateLabel() : string {
        if (!this.endDate.selectedDate) { return ""; }
        return `${this.getDate(this.startDate.selectedDate)}
                    <svg class="vc-icon ml-3" style="width: 8px;" viewBox="0 0 100 100">
                                            <use xlink:href="#shevron-down-icon" />
                                        </svg>`;
    }

    get toDateLabel() : string {
        if (!this.endDate.selectedDate) { return ""; }
        return `${this.getDate(this.endDate.selectedDate)}  <svg class="vc-icon ml-3" style="width: 8px;" viewBox="0 0 100 100">
                                            <use xlink:href="#shevron-down-icon" />
                                        </svg>`;
    }

    get calendarConfigs() {
        return calendarConfigs();
    }

    // methods
    open(playerId: string) {
        this.playerId = playerId;
        this.$bvModal.show("modal-playerLogs");

        const endDate = new Date();
        const tempDate = new Date();
        tempDate.setDate(tempDate.getDate() - 1);
        const startDate = tempDate;

        this.$nextTick(() => {
            (this.$refs.calendarFromDate as any).clickDay({
                day: startDate,
                date: `${startDate.getDate()}/${startDate.getMonth() + 1}/${startDate.getFullYear()}`,
                isMarked: true
            });
            (this.$refs.calendarToDate as any).clickDay({
                day: endDate,
                date: `${endDate.getDate()}/${endDate.getMonth() + 1}/${endDate.getFullYear()}`,
                isMarked: true
            });
        });
    }

    fetchData() {
        getLogs({
            playerId: this.playerId,
            startDate: this.getDate(this.startDate.selectedDate),
            endDate: this.getDate(this.endDate.selectedDate, true)
        } as PlayerLogFilterDto).then(response => {
            this.logs = response;
        });
    }

    hide() {
        this.$bvModal.hide("modal-playerLogs");
    }

    getDate(date: string, addDay: boolean = false) {
        const dateParts = date.split("/");
        return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1,
            addDay ? parseInt(dateParts[0]) + 1 : parseInt(dateParts[0]))
            .toLocaleString("en-US", { year: "numeric", month: "long", day: "numeric" });
    }

    clickedDay() {
        this.$nextTick(() => {
            this.fetchData();
        });
    }
}
